import { ProjectActivities } from '../redux/actions/projectActions/types';
import { toShortUtcDate } from './dateHelper';

/**
 * Notification section headers use the server's UTC day bucket.
 * CreatedOn is saved as DateTime.UtcNow; GetProjectNotifications groups by UTC calendar date.
 * Do not convert to the viewer's local timezone — product policy is one timeline for all regions.
 */
export const getUtcDateLabelForDayGroup = (dayGroup: ProjectActivities): string => {
    return toShortUtcDate(dayGroup.date);
};
